(() => {
  const SECTION_SELECTOR = '[data-hq-user-community]';
  const COUNTER_SELECTOR = '[data-hq-community-counter]';

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const parseMetric = (rawValue) => {
    const raw = String(rawValue || '').trim();

    const numberMatch = raw.match(/-?\d+(?:\.\d+)?/);

    if (!numberMatch) {
      return null;
    }

    const target = Number(numberMatch[0]);

    if (!Number.isFinite(target)) {
      return null;
    }

    const numberStart = numberMatch.index || 0;
    const numberEnd = numberStart + numberMatch[0].length;

    return {
      target,
      prefix: raw.slice(0, numberStart),
      suffix: raw.slice(numberEnd),
      decimals: (numberMatch[0].split('.')[1] || '').length
    };
  };


  const formatMetric = (value, metric) => {
    const numeric = metric.decimals > 0
      ? value.toFixed(metric.decimals)
      : Math.round(value).toString();

    return `${metric.prefix}${numeric}${metric.suffix}`;
  };


  const easeOutQuint = (progress) => {
    return 1 - Math.pow(1 - progress, 5);
  };


  const animateCounter = (
    element,
    metric,
    delay = 0,
    duration = 1450
  ) => {
    if (element.dataset.hqCounterAnimated === 'true') {
      return;
    }

    element.dataset.hqCounterAnimated = 'true';

    const finalValue =
      element.dataset.hqCommunityCounterValue ||
      element.textContent.trim();

    if (prefersReducedMotion.matches) {
      element.textContent = finalValue;
      element.classList.add('is-counted');
      return;
    }

    element.classList.add('is-counting');

    const startAnimation = () => {
      const startTime = performance.now();

      const frame = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = easeOutQuint(progress);

        const currentValue = metric.target * eased;

        element.textContent = formatMetric(
          currentValue,
          metric
        );

        if (progress < 1) {
          requestAnimationFrame(frame);
          return;
        }

        element.textContent = finalValue;

        element.classList.remove('is-counting');
        element.classList.add('is-counted');
      };

      requestAnimationFrame(frame);
    };

    window.setTimeout(startAnimation, delay);
  };


  const prepareSection = (section) => {
    if (
      !section ||
      section.dataset.hqCommunityInitialized === 'true'
    ) {
      return;
    }

    section.dataset.hqCommunityInitialized = 'true';

    const counters = Array.from(
      section.querySelectorAll(COUNTER_SELECTOR)
    );

    if (!counters.length) {
      return;
    }

    const parsedCounters = counters
      .map((element) => {
        const finalValue =
          element.dataset.hqCommunityCounterValue ||
          element.textContent.trim();

        return {
          element,
          metric: parseMetric(finalValue),
          finalValue
        };
      })
      .filter((item) => item.metric);


    if (!prefersReducedMotion.matches) {
      parsedCounters.forEach(({ element, metric }) => {
        element.textContent = formatMetric(0, metric);
      });
    }


    const runCounters = () => {
      parsedCounters.forEach(
        ({ element, metric }, index) => {
          animateCounter(
            element,
            metric,
            index * 90,
            1450
          );
        }
      );
    };


    if (prefersReducedMotion.matches) {
      parsedCounters.forEach(({ element, finalValue }) => {
        element.textContent = finalValue;
        element.classList.add('is-counted');
      });

      return;
    }


    if (!('IntersectionObserver' in window)) {
      runCounters();
      return;
    }


    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.some(
          (entry) =>
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.2
        );

        if (!visible) {
          return;
        }

        observer.disconnect();
        runCounters();
      },
      {
        threshold: [0.2, 0.35],
        rootMargin: '0px 0px -8% 0px'
      }
    );

    observer.observe(section);
  };


  const initAll = () => {
    document
      .querySelectorAll(SECTION_SELECTOR)
      .forEach(prepareSection);
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );
  } else {
    initAll();
  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const section =
        event.target.querySelector(SECTION_SELECTOR) ||
        (
          event.target.matches &&
          event.target.matches(SECTION_SELECTOR)
            ? event.target
            : null
        );

      prepareSection(section);
    }
  );
})();